import React, {Component} from 'react';
import { View, Text} from 'react-native';

import ff from './ff';
import cf from './cf';
import ce from './ce';
import ic from './ic';
import bf from './bf';
//import iv from './iv';

//import df from './df_20211115';
import myWB from './myWB_20211212';

import cView from './cView';

import c20v1a from './c20v1a';

//export default class c00v extends React.Component {
export default class c00v extends cView {

  state = cf.myRN_crt_stss({
    s_eml: '',
    s_nmb: '',
    s_step: '0',
    s_id: null,
    sb_cookie: false,
  })


$clp_loadLists = () => [
  new Promise( _o_end1 => {
    cf.myLS_chk()
    .then( _b_res => {
//ff.l('c00v 34: {}'.f(_b_res));
      cf.myRN_setStt({
        sb_cookie: _b_res,
      })
      .then(() => {
        _o_end1();
      });
    });
  }),
  new Promise( _o_end2 => {
    new Promise( _o_end1 => { // サブドメインに紐づいた利用会社・認証区分の設定
      let _d_dmns = myWB.myWB_getDmn(); // サブドメインが存在する場合のみ有効
      let _cnd = `c01rc11s = "${_d_dmns.subDmn}"`;
      cf.myCB_call_slc({
        ctr: 'nlm',
        elm: 'c01r',
        n_dms: 3, // 3 でないと dd_rfrss が機能しない
        cnd: _cnd,
        dd_rfrss: {
          c20r: {
            elm: 'c20r',
            o_cnd: _d_flds => {
              let _cnd = cf.c('c20r', `_fst = ${_d_flds.c01rb21f}`, true, true); // c20r_fst がまだ設定されてない
              return _cnd;
            }
          },
        }
      })
      .then( _ld_c01rss => {
        if (ff.f(_ld_c01rss)) {
          let _d_c01rs = _ld_c01rss[0];
          cf.myRN_saveCmnStgs({
            c20r_fst: _d_c01rs.c01rb21f, // 利用会社
            c20r_pfx: (_d_c01rs.c20rc31s) ? _d_c01rs.c20rc31s : (_d_c01rs.c20rc33s ?? ''), // 利用会社名
            c01rt11i: _d_c01rs.c01rt11i, // 利用者区分
            c01rt21i: _d_c01rs.c01rt21i, // 認証区分
          })
          .then(() => {
            c20v1a.op_loadDtl({ // 設定情報の取得に必要
              elm: 'c20r',
            })
            .then(() => {
              _o_end1();
            })
          })
        }
        else {
          cf.myRN_saveCmnStgs({
            c20r_fst: -1, // 利用会社
            c20r_pfx: '', // 利用会社名
            c01rt11i: -1, // 利用者区分
            c01rt21i: -1, // 認証区分
          })
          .then(() => {
            _o_end1();
          });
        };
      })
    }).then(() => {
      let _id = ff.myCM_cnv('dcd-6dgt', { n_nbr: ff.n(cf.myNV_getId()) });
      if ( _id > 0 ) { // URLで団体が指定されている場合
        cf.myRN_setStt({ 
          s_id: _id,
        })
        .then(() => {
          cf.myRN_saveCmnStgs({
            c01rt21i: 30, // 認証区分
          })
          .then(() => {
            cf.myRN_setStt({ // ログイン画面の表示
              s_eml: '',
              s_nmb: '',
              s_step: '10',
            })
            .then(_o_end2);
          });
        })
      }
      else { // URLでユーザが指定されてない場合
        if (global.t?.state.sgcd_cmnStgs?.c10r_key == 0 || ff.f(global.t?.state.sgcd_cmnStgs?.c10r_key)){ // 認証済の場合
          let _cnd = cf.c('c10r', `_key = ${global.t?.state.sgcd_cmnStgs?.c10r_key}`, false, false); // cf.c は c20r_fst 設定後から利用可能
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'c10r', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_c10rs => {
            c00v._setC10rs(_d_c10rs, (global.t?.d_viewDefs.class == 'c00v1a') ? true : false);
            _o_end2();
          });
        }
        else { // 未認証の場合
          cf.myRN_setStt({ // ログイン画面の表示
            s_eml: '',
            s_nmb: '',
            s_step: '10',
          })
          .then(() => {
            _o_end2();
          });
        };
      }
    });
  }),
];

static _setC10rs = (pd_c10rs, pb_move) => new Promise( _o_end1 => {
  if (pd_c10rs.c10rb21f == 0 || ff.f(pd_c10rs.c10rb21f)) { // c20r_fst が指定されている場合
    let _cnd = `
      COALESCE(c20rcz1i,10) <> 0
      AND _vsn = _ltt
      AND _fst = ${pd_c10rs.c10rb21f}
    `;
    //ff.l('c00v 75: {}'.f(_cnd));
    cf.myCB_call_slc({
      ctr: 'nlm', 
      elm: 'c20r', 
      n_dms: 2, 
      cnd: _cnd, 
    })
    .then( _d_c20rs => {
      //ff.l('c00v 79: {}'.f(_d_c20rs));
      if (_d_c20rs) {
        cf.myRN_saveCmnStgs({
          c20r_fst: _d_c20rs._fst, // _key は、必要性がなく、誤用を回避するため、使用しない
          c20r_pfx: (_d_c20rs.c20rc31s) ? _d_c20rs.c20rc31s : (_d_c20rs.c20rc33s ?? ''),
        })
        .then(() => {
          let _cnd = cf.c('c10r', `_key = ${pd_c10rs._key}`, false, false) // c10r は歴管理の対象外, cf.c は c20r_fst 設定後に利用可能
          //ff.l('90: {}'.f(_cnd));
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'c10r', 
            n_dms: 2, 
            cnd: _cnd, 
          })
          .then( _d_c10rs => {
            //ff.l('105: {}'.f(_d_c10rs))
            if (_d_c10rs) {
              cf.myRN_saveCmnStgs({
                c10r_key: _d_c10rs._key, // c10r は 歴管理の対象外
                c10r_pfx: (_d_c10rs.c10rc31s) ? _d_c10rs.c10rc31s : (_d_c10rs.c10rc33s ?? ''),
                c10rt11i: _d_c10rs.c10rt11i,
                c10rb31f: _d_c10rs.c10rb31f, // 所属組織
              })
              .then(() => {
                if (pb_move == true) { // ログイン画面の場合
                  let _d_pageInfs =  ic.get_iniPageInfs(_d_c10rs.c10rt11i);
                  //ff.l('110: {}'.f(_d_pageInfs))
                  cf.myRN_move_fwd(_d_pageInfs);
                  _o_end1();
                }
                else {
                  _o_end1();
                };
              });
            }
            else {
              _o_end1();
            };
          });
        });
      }
      else {
        _o_end1();
      };
    });
  }
  else {
    _o_end1();
  };
});
  
}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
